import { jsx as _jsx } from "react/jsx-runtime";
import { ShoppingCartFillIcon } from '@yonderland/andes-icons';
import { ButtonAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { useProductDetailContext } from '../../../containers/product/ProductDetailV2Container';
export const AddToBasketButton = ({ onClick, quantity = 1, isStickyBar, disabled = false, buttonSize, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { ctaRef } = useProductDetailContext();
    const handleClick = () => {
        onClick(quantity);
    };
    const icon = {
        source: ShoppingCartFillIcon,
        size: 'sm',
    };
    return (_jsx(ButtonAlpha, { innerRef: !isStickyBar ? ctaRef : undefined, theme: "branded", variant: "primary", state: disabled ? 'disabled' : 'interactive', fullWidth: true, testId: "add_to_basket", onClick: handleClick, text: t('product:pdp.cart.addtobasket.btn'), size: buttonSize !== null && buttonSize !== void 0 ? buttonSize : 'md', iconLeft: icon }));
};
